<template>
  <div class="py-8 mt-8 flex flex-col items-center gap-4 text-center">
    <div
      class="w-full max-w-[760px] rounded-lg border-2 border-[#FF0000] bg-black/40 px-4 md:px-8 py-6 flex flex-col gap-4"
    >
      <h2 class="text-[#FF0000] font-russo text-xl md:text-2xl">{{ heading }}</h2>
      <p class="text-[16px] md:text-[18px] text-white">{{ body }}</p>
      <ul class="flex flex-wrap justify-center gap-2 md:gap-3" dir="ltr">
        <li
          v-for="l in languages"
          :key="l"
          class="rounded border border-[#555] bg-black/60 px-3 py-1 text-[15px] md:text-[16px] text-white"
        >
          {{ l }}
        </li>
      </ul>
      <picture class="contents">
        <source
          srcset="/images/system-language/language-selector.webp"
          type="image/webp"
        />
        <img
          decoding="async"
          loading="lazy"
          width="502"
          height="547"
          src="/images/system-language/language-selector.png"
          class="m-auto rounded border border-[#444] max-w-[380px] w-full h-auto"
          :alt="imgAlt"
        />
      </picture>
      <p v-if="menuPath" class="text-[14px] md:text-[15px] text-[#999999]">
        {{ menuPath }}
      </p>
      <p
        v-if="mapLangs"
        class="text-[14px] md:text-[15px] text-[#cfcfcf] border-t border-[#555] pt-4"
      >
        {{ mapLangs }}
      </p>
    </div>
  </div>
</template>

<script>
// The languages the Rally Navigator desktop UI supports (native names, in the
// order they appear in the app's System and Menu Language menu). Shown on the
// pillar pages whose own language the app UI does NOT support, so visitors can
// spot another language they read.
const SUPPORTED = [
  'English',
  'Français',
  'Português',
  'العربية',
  'Español',
  'Lietuvių',
  'Deutsch',
  'Ελληνικά',
  'Italiano',
  'Polski',
  'Русский',
  '日本語',
  'Български',
  '中文',
];

export default {
  name: 'LanguageAvailability',
  props: {
    heading: { type: String, required: true },
    body: { type: String, required: true },
    menuPath: { type: String, default: '' },
    mapLangs: { type: String, default: '' },
    imgAlt: {
      type: String,
      default:
        'Rally Navigator first-launch Language Selector pop-up listing all 14 supported languages',
    },
  },
  data() {
    return { languages: SUPPORTED };
  },
};
</script>

<style scoped></style>
